import { render, staticRenderFns } from "./SavedGames.vue?vue&type=template&id=f87df544&scoped=true"
import script from "./SavedGames.vue?vue&type=script&lang=js"
export * from "./SavedGames.vue?vue&type=script&lang=js"
import style0 from "./SavedGames.vue?vue&type=style&index=0&id=f87df544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87df544",
  null
  
)

export default component.exports